import { rootActions, useAppDispatch, useAppSelector } from '../../data-services/store';
import PRDAddToCart from "./prd-add-to-cart";
import PRDPrice from "./prd-price";
import {ProductsRelDocs} from "../../interfaces";
import PRDPriceNote from "./prd-price-note";
import PRDPriceSubscriptionPlan from "./prd-price-subscription-plan";
import PRDPriceDifferentSubscriptionPlan from "./prd-price-different-subscription-plan";
interface IProductBuyButtonProps {
    product: ProductsRelDocs,
    isGoogleShoppingFeed?: boolean,
    styleAddToCartMode?: string,
}
/**
 * the entry point
 */
const ProductOptions= (props: IProductBuyButtonProps) => {

    const dispatch = useAppDispatch();
    const productsRelDocsInitial_List = useAppSelector((store) => store.productsRelDocsInitial);
    const isProductOptionsSelected = useAppSelector((store) => store.isProductOptionsSelected);
    const isProductOptionsTouched = useAppSelector((store) => store.isProductOptionsTouched);
    const isSubsctiptionPlan = useAppSelector((store) => store.isSubsctiptionPlan);
    //const isUrlSelect = useAppSelector((store) => store.isUrlSelect);
    const product = props.product;
    const title = product && product.categoryDisplayName ? product.categoryDisplayName : 'Size';
    const isProductNote = !product.skuEnabled && product.note != null && product.note !== '';
    const _productOptions = JSON.parse(JSON.stringify(productsRelDocsInitial_List)) as ProductsRelDocs[]
    _productOptions.sort((a,b) => a.optionOrder - b.optionOrder);
    const isPriceDifferent =  _productOptions.some( product=> product.msrp !== product.skuPrice);
    //console.log(`ProductOptions._productOptions: `, _productOptions);

    return (
                <>
                        <div className="product-options w-full  flex flex-row  items-center justify-start pb-2"><span
                            className="pr-2">Choose {title}</span>
                            {_productOptions.map(variant => {
                                return (
                                    <button key={variant.skuid}
                                        className={`w-fit px-4 py-1 w-btn-outline-white hover:w-btn-outline-white-hover text-sm flex items-center justify-center mr-2 ${variant.skuid}_variant_skuid ${product.skuid}_product_skuid ${isProductOptionsSelected && variant.skuid === product.skuid ? 'selected-variant w-btn-outline-white-hover' : ''}`}
                                        onClick={evt => {
                                            dispatch(
                                                rootActions.main({
                                                    isProductOptionsSelected: true,
                                                    productsRelDocsInitialSelected: variant
                                                })
                                            );
                                        }}>{variant.optionName}</button>
                                )
                            })}
                        </div>

                    {
                        isProductOptionsTouched && !isProductOptionsSelected &&
                        <div className="mt-2 text-red" role="alert">Please choose {title.toLowerCase()}</div>
                    }
                    {isProductNote && <div className="w-full flex flex-wrap justify-center mt-4"><PRDPriceNote product={product} sourceCode="prd-options"/></div>}

                    {!isSubsctiptionPlan && !isProductNote && <PRDPrice product={product}/>}

                    {isSubsctiptionPlan && !isPriceDifferent && !isProductNote && <PRDPriceSubscriptionPlan product={product}/>}
                    {isSubsctiptionPlan && isPriceDifferent && !isProductNote && <PRDPriceDifferentSubscriptionPlan product={product}/>}

                    {!isProductNote && <PRDAddToCart product={product} isPriceDifferent={isPriceDifferent} />}
                </>

    )
};

export default ProductOptions;